import {
  Workspace_AddRequest,
  Workspace_Delete_Response,
  Workspace_FindPage_RequestQuery,
  Workspace_FindPage_Response,
  Workspace_Response,
  Workspace_Update_Request,
  Workspace_Update_Response,
} from '../models/Workspace';
import {
  AC_Workspace_addRoleForUser_Request,
  AC_Workspace_addRoleForUser_Response,
  AC_Workspace_deleteRoleForUser_Request_Query,
  AC_Workspace_deleteRoleForUser_Response,
  AC_Workspace_getUsersWithRoles_Request_Query,
  AC_Workspace_getUsersWithRoles_Response,
} from '../services/access_control/AC_Workspace';
import { getAxiosInstance } from '../../react/utils/networkUtil';
import { AppSuccess } from '@common/models/AppSuccess';

export const remote_workspace_findPage = async (
  request: Workspace_FindPage_RequestQuery,
): Promise<Workspace_FindPage_Response> => {
  return (
    await getAxiosInstance().get('/api/workspaces-ext', {
      params: request,
    })
  ).data;
};

export const remote_getMyWorkspaces = async (): Promise<Array<Workspace_Response>> => {
  return (await getAxiosInstance().get('/api/workspaces-ext/me')).data;
};

export const remote_createWorkspace = async (body: Workspace_AddRequest): Promise<AppSuccess<Workspace_Response>> => {
  const response = await getAxiosInstance().post('/api/workspaces-ext', body);
  return response.data; // AppSuccess wrapper
};

export const remote_getUsers_with_Roles = async (
  query: AC_Workspace_getUsersWithRoles_Request_Query,
): Promise<AC_Workspace_getUsersWithRoles_Response> => {
  return (
    await getAxiosInstance().get('/api/acl-workspace-ext/users-with-roles', {
      params: query,
    })
  ).data;
};

export const remote_addRoleForUser = async (
  data: AC_Workspace_addRoleForUser_Request,
): Promise<AC_Workspace_addRoleForUser_Response> => {
  return (
    await getAxiosInstance().post('/api/acl-workspace-ext/roles', {
      data: data,
    })
  ).data;
};

export const remote_deleteRoleForUser = async (
  query: AC_Workspace_deleteRoleForUser_Request_Query,
): Promise<AC_Workspace_deleteRoleForUser_Response> => {
  return (
    await getAxiosInstance().delete('/api/acl-workspace-ext/roles', {
      params: query,
    })
  ).data;
};

export const remote_Workspace_update = async (
  id: number,
  request: Workspace_Update_Request,
): Promise<Workspace_Update_Response> => {
  return (await getAxiosInstance().put(`/api/workspaces-ext/${id}`, request)).data;
};

export const remote_Workspace_delete = async (id: number): Promise<Workspace_Delete_Response> => {
  return (await getAxiosInstance().delete(`/api/workspaces-ext/${id}`)).data;
};
